var Modal = require("components/utility/AltModal");
var CurrentUser = require("lib/account/CurrentUser");
var AutograderDemo = require("components/writing/evaluations/AutograderDemo.js")

require("writing/responses/name_modal.scss");

class GlobalModalContainer extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = { modalConfig: null }
  }

  setInitalState() {
    for (var key in MODALS) {
      var modalConfig = MODALS[key]
      if (modalConfig.active && modalConfig.trigger(this.props)) {
        this.setState({ modalConfig }, () => {
          this.refs.globalModal.show()
        })
        break;
      }
    }
  }

  renderModal() {
    var { modalConfig } = this.state
    if (modalConfig) {
      var content = modalConfig.action(this.props)
      var headerText = modalConfig.headerText
      var classes = modalConfig.classes
    }

    return (
      <Modal className={`globalModal ${classes}`} ref="globalModal" headerText={headerText || ''}>
        {content}
      </Modal>
    )
  }

  render() {
    return this.renderModal()
  }

  pageOrParamsChanged(prevProps) {
    return (this.props.location.path !== prevProps.location.path) || (this.props.location.search !== prevProps.location.search)
  }

  componentDidMount() {
    this.setInitalState()
  }

  componentDidUpdate(prevProps) {
    if (this.pageOrParamsChanged(prevProps)) {
      this.setInitalState()
    }
	}
};

var MODALS = {
// AUTOGRADER DEMO NO LONGER SUPPORTED BY ALEX V5
//   'autograder-demo': {
//     active: true,
//     trigger: (props) => { 
//       // if (CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard && Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-checklist")) { // TEMP COMMENT
//       if (CurrentUser.get() !== undefined && !CurrentUser.get().is_student && !CurrentUser.get().is_wizard) {
//         var searchParams = props.location.search.replace('?', '').split('&');
//         return _.includes(searchParams, 'autograderDemo=show')
//       }
//     },
//     action: (props) => { return <AutograderDemo /> },
//     classes: 'onboardingModal',
//     headerText: 'Try Our Autograder'
//   }
}

GlobalModalContainer.propTypes = StrictPropTypes({
  location: PropTypes.object
});

module.exports = GlobalModalContainer;



// WEBPACK FOOTER //
// ./modules/components/notifications/GlobalModalContainer.js